export default {
  title: 'Artikel',
  order_note: 'Anmerkung zur Bestellung',
};
